import { SafeUrl } from '@angular/platform-browser';

export class Image {
  id: string;
  url: string;
  metadata: any;
  url_expires: any
  status?: boolean;
  janetdata? : any;
  analysisData? : any;
  summaryData?: any;
  thumbnailUrl?: SafeUrl;
  objectId?: string;
  reportId?: string;
  assetId?: string;
}
